import React from 'react';

const TickCircleFill = (props: object) => {
  return (
    <svg
      width="54"
      height="55"
      viewBox="0 0 54 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 54.5C30.5457 54.5 34.0567 53.8016 37.3325 52.4447C40.6082 51.0879 43.5847 49.0991 46.0919 46.5919C48.5991 44.0847 50.5879 41.1082 51.9447 37.8325C53.3016 34.5567 54 31.0457 54 27.5C54 23.9543 53.3016 20.4433 51.9447 17.1675C50.5879 13.8918 48.5991 10.9153 46.0919 8.40812C43.5847 5.90093 40.6082 3.91213 37.3325 2.55525C34.0567 1.19838 30.5457 0.5 27 0.5C19.8392 0.5 12.9716 3.34463 7.90812 8.40812C2.84464 13.4716 0 20.3392 0 27.5C0 34.6608 2.84464 41.5284 7.90812 46.5919C12.9716 51.6554 19.8392 54.5 27 54.5ZM41.304 20.42L36.696 16.58L23.796 32.057L17.121 25.379L12.879 29.621L24.201 40.943L41.304 20.42Z"
        fill="#6CDA75"
      />
    </svg>
  );
};

export default TickCircleFill;
